/**
 * Child acquisition partner referral codes, from the wervingsportaal.
 * Terraform sets the flag where the portal exists.
 */
export const ACQUISITION_PARTNERS_ENABLED =
  import.meta.env.VITE_FEATURE_ACQUISITION_PARTNERS === "true";

// Mirrors REFERRAL_CODE_ALPHABET / REFERRAL_CODE_LENGTH in api/src/schemas/acquisition-partner.ts:
// 8 characters without lookalikes. Viral Loops codes are 7 and promo codes are keywords,
// so the format alone says which kind a code typed into the shared field is. (Links
// carry it in their own `partnerCode` parameter; see onboarding/route.tsx.)
const PARTNER_REFERRAL_CODE = /^[23456789ABCDEFGHJKMNPQRSTVWXYZ]{8}$/;

export const isPartnerReferralCode = (code: string): boolean =>
  PARTNER_REFERRAL_CODE.test(code.toUpperCase().replace(/[\s-]/g, ""));
